<script lang="ts">
  import { onMount } from 'svelte';
  import { getAppConfig } from '../../../common/config/app-config';
  import { getCMSComponentsFromHybrisAsync } from '../../common/services/hybris';
  import ImageBannerVer1 from '../lazy-components/amplienceBanners/imageBannerVer1.svelte';
  import MegaSaleOnlineNow from './MegaSaleOnlineNow.svelte';
  import MegaSaleVoucher from './MegaSaleVoucher.svelte';
  const { megaSaleComponentId, primeLevel, isMegaSaleDuringAccessStarted } = getAppConfig();

  export let bannerClass = null;
  let isLoaded = false;
  let pdpBannerData;

  onMount(async () => {
    getCMSComponentsFromHybrisAsync([megaSaleComponentId]).then(res => {
      if (res?.component?.[0]) {
        const { amplienceId, blueAmplienceId, goldAmplienceId } = res.component[0];
        pdpBannerData = {
          amplienceId,
          blueAmplienceId,
          goldAmplienceId,
        };
        isLoaded = true;
      }
    });
  });
</script>

{#if isLoaded && pdpBannerData}
  <div class="c_megasale pdp-megasale-banner {bannerClass}">
    {#if isMegaSaleDuringAccessStarted && primeLevel}
      <MegaSaleVoucher pageClass="pdp-megasale-voucher" />
    {/if}
    <MegaSaleOnlineNow pageClass="pdp-megasale-livenow" />
    <ImageBannerVer1 metaData={pdpBannerData} isDynamicRender="false" />
  </div>
{/if}
